export var ActionPermission;
(function (ActionPermission) {
    ActionPermission["USERS_ALL"] = "users.*";
    ActionPermission["USERS_READ"] = "users.read";
    ActionPermission["USERS_READ_DELETED"] = "users.read_deleted";
    ActionPermission["USERS_READ_SAVED_INFO"] = "users.read_saved_info";
    ActionPermission["USERS_READ_COMPLIANCE"] = "users.read_compliance";
    ActionPermission["USERS_READ_STATISTICS"] = "users.read_statistics";
    ActionPermission["USERS_READ_LOGIN_HISTORY"] = "users.read_login_history";
    ActionPermission["USERS_EDIT_PHONE"] = "users.edit_phone";
    ActionPermission["USERS_EDIT_STATUS"] = "users.edit_status";
    ActionPermission["USERS_EDIT_JURISDICTION"] = "users.edit_jurisdiction";
    ActionPermission["USERS_EDIT_RISK_LEVEL"] = "users.edit_risk_level";
    ActionPermission["USERS_EDIT_REFERRER_CODE"] = "users.edit_referrer_code";
    // STODO should uncomment when referral is added USERS_EDIT_REFERRER_CODE = 'users.edit_referrer_referral_code', // usePersonalInformation done
    ActionPermission["USERS_EDIT_NAME"] = "users.edit_name";
    ActionPermission["USERS_EDIT_ID_NUMBER"] = "users.edit_id_number";
    ActionPermission["USERS_EDIT_EMAIL"] = "users.edit_email";
    ActionPermission["USERS_READ_ID_NUMBER"] = "users.read_id_number";
    ActionPermission["USERS_EDIT_USER_GROUP"] = "users.edit_user_group";
    ActionPermission["USERS_EDIT_KYC_STATUS"] = "users.edit_kyc_status";
    ActionPermission["USERS_BLOCK"] = "users.block";
    ActionPermission["USERS_EDIT_2FA"] = "users.edit_2fa";
    ActionPermission["USERS_EXPORT_EXCEL"] = "users.export_excel";
    ActionPermission["USERS_DOCUMENT_EXPORT_EXCEL"] = "users.document_export_excel";
    ActionPermission["USERS_UPDATE"] = "users.update";
    ActionPermission["USERS_RESET_KYC"] = "users.reset_kyc";
    ActionPermission["USERS_TOGGLE_CARD_DEPOSIT_ENABLED"] = "users.toggle_card_deposit_enabled";
    ActionPermission["USERS_COMPLIANCE_EXPORT_EXCEL"] = "users.compliance_export_excel";
    ActionPermission["USERS_EDIT_CARD_APPROVAL"] = "users.edit_card_approval";
    ActionPermission["USERS_UNBLOCK_CARD_ADDITION_TIMER"] = "users.unblock_card_addition_timer";
    ActionPermission["USERS_UNBLOCK_CARD_DEPOSIT_TIMER"] = "users.unblock_card_deposit_timer";
    ActionPermission["USERS_SET_CARD_LIMIT"] = "users.set_card_limit";
    ActionPermission["USERS_SET_CARD_APPROVAL"] = "users.set_card_approval";
    ActionPermission["USERS_DELETE"] = "users.delete";
    ActionPermission["KYC_DETAILS_READ"] = "kyc_details.read";
    ActionPermission["USER_DOCUMENTS_ALL"] = "user_documents.*";
    ActionPermission["USER_DOCUMENTS_READ"] = "user_documents.read";
    ActionPermission["USER_DOCUMENTS_DELETE"] = "user_documents.delete";
    ActionPermission["FILES_ALL"] = "files.*";
    ActionPermission["FILES_READ"] = "files.read";
    ActionPermission["FILES_CREATE"] = "files.create";
    ActionPermission["FILES_UPDATE"] = "files.update";
    ActionPermission["FILES_DELETE"] = "files.delete";
    ActionPermission["FILES_EXPORT_EXCEL"] = "files.export_excel";
    ActionPermission["ASSETS_ALL"] = "assets.*";
    ActionPermission["ASSETS_READ"] = "assets.read";
    ActionPermission["ASSETS_CREATE"] = "assets.create";
    ActionPermission["ASSETS_UPDATE"] = "assets.update";
    ActionPermission["ASSETS_DELETE"] = "assets.delete";
    ActionPermission["LOANS_ALL"] = "loans.*";
    ActionPermission["LOANS_READ"] = "loans.read";
    ActionPermission["LOANS_RELEASE_COLLATERAL"] = "loans.release_collateral";
    ActionPermission["LOANS_LIQUIDATE"] = "loans.liquidate";
    ActionPermission["LOAN_REQUEST_ALL"] = "loan_request.*";
    ActionPermission["LOAN_REQUEST_READ"] = "loan_request.read";
    ActionPermission["LOAN_REQUEST_APPROVE"] = "loan_request.approve";
    ActionPermission["LOAN_REQUEST_REJECT"] = "loan_request.reject";
    ActionPermission["LOAN_REQUEST_UPDATE_INTEREST"] = "loan_request.update_interest";
    ActionPermission["BALANCES_ALL"] = "balances.*";
    ActionPermission["BALANCES_READ"] = "balances.read";
    ActionPermission["BALANCES_EDIT"] = "balances.edit";
    ActionPermission["BALANCES_EXPORT_EXCEL"] = "balances.export_excel";
    ActionPermission["BALANCES_READ_PLATFORM_BALANCES"] = "balances.read_platform_balances";
    ActionPermission["USER_GROUPS_ALL"] = "user_groups.*";
    ActionPermission["USER_GROUPS_READ"] = "user_groups.read";
    ActionPermission["USER_GROUPS_CREATE"] = "user_groups.create";
    ActionPermission["USER_GROUPS_UPDATE"] = "user_groups.update";
    ActionPermission["USER_GROUPS_DELETE"] = "user_groups.delete";
    ActionPermission["USER_GROUPS_ADD_USERS"] = "user_groups.add_users";
    ActionPermission["USER_GROUPS_REMOVE_USERS"] = "user_groups.remove_users";
    ActionPermission["USER_GROUPS_EDIT_NAME"] = "user_groups.edit_name";
    ActionPermission["TRANSACTIONS_ALL"] = "transactions.*";
    ActionPermission["TRANSACTIONS_READ"] = "transactions.read";
    ActionPermission["TRANSACTIONS_EXPORT_EXCEL"] = "transactions.export_excel";
    ActionPermission["TRANSACTIONS_READ_STATISTICS"] = "transactions.read_statistics";
    ActionPermission["TRANSACTIONS_READ_STATISTICS_COUNT"] = "transactions.read_statistics_count";
    ActionPermission["TRANSACTIONS_READ_STATISTICS_SUM"] = "transactions.read_statistics_sum";
    ActionPermission["BANK_WIRE_DEPOSIT_ALL"] = "bank_wire_deposit.*";
    ActionPermission["BANK_WIRE_DEPOSIT_READ"] = "bank_wire_deposit.read";
    ActionPermission["BANK_WIRE_WITHDRAWAL_ALL"] = "bank_wire_withdrawal.*";
    ActionPermission["BANK_WIRE_WITHDRAWAL_CREATE_IN_BANK"] = "bank_wire_withdrawal.create_in_bank";
    ActionPermission["BANK_WIRE_WITHDRAWAL_CHANGE_STATUS"] = "bank_wire_withdrawal.change_status";
    ActionPermission["BANK_WIRE_WITHDRAWAL_TRIGGER_BANK_TRANSACTION"] = "bank_wire_withdrawal.trigger_bank_transaction";
    ActionPermission["EXCHANGE_PAIRS_ALL"] = "exchange_pairs.*";
    ActionPermission["EXCHANGE_PAIRS_READ"] = "exchange_pairs.read";
    ActionPermission["EXCHANGE_PAIRS_CREATE"] = "exchange_pairs.create";
    ActionPermission["EXCHANGE_PAIRS_UPDATE"] = "exchange_pairs.update";
    ActionPermission["EXCHANGE_PAIRS_DELETE"] = "exchange_pairs.delete";
    ActionPermission["EXCHANGE_PAIRS_ADD"] = "exchange_pairs.add";
    ActionPermission["EXCHANGE_PAIRS_REMOVE"] = "exchange_pairs.remove";
    ActionPermission["EXCHANGE_RATES_ALL"] = "exchange_rates.*";
    ActionPermission["EXCHANGE_RATES_READ"] = "exchange_rates.read";
    ActionPermission["EXCHANGE_RATE_MARGINS_ALL"] = "exchange_rate_margins.*";
    ActionPermission["EXCHANGE_RATE_MARGINS_READ"] = "exchange_rate_margins.read";
    ActionPermission["EXCHANGE_RATE_MARGINS_EXPORT_EXCEL"] = "exchange_rate_margins.export_excel";
    ActionPermission["EXCHANGE_RATE_MARGINS_CREATE"] = "exchange_rate_margins.create";
    ActionPermission["EXCHANGE_RATE_MARGINS_UPDATE"] = "exchange_rate_margins.update";
    ActionPermission["EXCHANGE_RATE_MARGINS_DELETE"] = "exchange_rate_margins.delete";
    ActionPermission["EXCHANGE_FEES_ALL"] = "exchange_fees.*";
    ActionPermission["EXCHANGE_FEES_READ"] = "exchange_fees.read";
    ActionPermission["EXCHANGE_FEES_EXPORT_EXCEL"] = "exchange_fees.export_excel";
    ActionPermission["EXCHANGE_FEES_UPDATE"] = "exchange_fees.update";
    ActionPermission["EXCHANGE_FEES_CREATE"] = "exchange_fees.create";
    ActionPermission["EXCHANGE_FEES_DELETE"] = "exchange_fees.delete";
    ActionPermission["ADMINS_ALL"] = "admins.*";
    ActionPermission["ADMINS_CREATE"] = "admins.create";
    ActionPermission["ADMINS_READ"] = "admins.read";
    ActionPermission["ADMINS_UPDATE"] = "admins.update";
    ActionPermission["ADMINS_DELETE"] = "admins.delete";
    ActionPermission["ADMINS_ADD_ROLES"] = "admins.add_roles";
    ActionPermission["ADMINS_ADD_JURISDICTION"] = "admins.add_jurisdiction";
    ActionPermission["ROLES_ALL"] = "roles.*";
    ActionPermission["ROLES_READ"] = "roles.read";
    ActionPermission["ROLES_CREATE"] = "roles.create";
    ActionPermission["ROLES_UPDATE"] = "roles.update";
    ActionPermission["ROLES_DELETE"] = "roles.delete";
    ActionPermission["ROLES_ADD_PERMISSION"] = "roles.add_permission";
    ActionPermission["ROLES_REMOVE_PERMISSION"] = "roles.remove_permission";
    ActionPermission["LIMITS_ALL"] = "limits.*";
    ActionPermission["LIMITS_READ"] = "limits.read";
    ActionPermission["LIMITS_CREATE"] = "limits.create";
    ActionPermission["LIMITS_UPDATE"] = "limits.update";
    ActionPermission["LIMITS_DELETE"] = "limits.delete";
    ActionPermission["NETWORKS_ALL"] = "networks.*";
    ActionPermission["NETWORKS_READ"] = "networks.read";
    ActionPermission["NETWORKS_CREATE"] = "networks.create";
    ActionPermission["NETWORKS_UPDATE"] = "networks.update";
    ActionPermission["NETWORKS_DELETE"] = "networks.delete";
    ActionPermission["ASSET_SUPPORTED_NETWORKS_ALL"] = "asset_supported_networks.*";
    ActionPermission["ASSET_SUPPORTED_NETWORKS_READ"] = "asset_supported_networks.read";
    ActionPermission["ASSET_SUPPORTED_NETWORKS_CREATE"] = "asset_supported_networks.create";
    ActionPermission["ASSET_SUPPORTED_NETWORKS_UPDATE"] = "asset_supported_networks.update";
    ActionPermission["ASSET_SUPPORTED_NETWORKS_DELETE"] = "asset_supported_networks.delete";
    ActionPermission["WITHDRAWAL_FEES_ALL"] = "withdrawal_fees.*";
    ActionPermission["WITHDRAWAL_FEES_READ"] = "withdrawal_fees.read";
    ActionPermission["WITHDRAWAL_FEES_CREATE"] = "withdrawal_fees.create";
    ActionPermission["WITHDRAWAL_FEES_UPDATE"] = "withdrawal_fees.update";
    ActionPermission["WITHDRAWAL_FEES_DELETE"] = "withdrawal_fees.delete";
    ActionPermission["WITHDRAWAL_FEES_EXPORT_EXCEL"] = "withdrawal_fees.export_excel";
    ActionPermission["EXCHANGES_ALL"] = "exchanges.*";
    ActionPermission["EXCHANGES_READ"] = "exchanges.read";
    ActionPermission["EXCHANGES_EXPORT_EXCEL"] = "exchanges.export_excel";
    ActionPermission["ASSET_GROUPS_ALL"] = "asset_groupfs.*";
    ActionPermission["ASSET_GROUPS_READ"] = "asset_groups.read";
    ActionPermission["ASSET_GROUPS_CREATE"] = "asset_groups.create";
    ActionPermission["ASSET_GROUPS_UPDATE"] = "asset_groups.update";
    ActionPermission["ASSET_GROUPS_DELETE"] = "asset_groups.delete";
    ActionPermission["PERMISSIONS_ALL"] = "permissions.*";
    ActionPermission["PERMISSIONS_READ"] = "permissions.read";
    ActionPermission["STAKING_TYPES_READ"] = "staking_types.read";
    ActionPermission["STAKING_TYPES_CREATE"] = "staking_types.create";
    ActionPermission["STAKING_TYPES_UPDATE"] = "staking_types.update";
    ActionPermission["STAKING_TYPES_ALL"] = "staking_types.*";
    ActionPermission["STAKING_TERMS_READ"] = "staking_terms.read";
    ActionPermission["STAKING_TERMS_CREATE"] = "staking_terms.create";
    ActionPermission["STAKING_TERMS_UPDATE"] = "staking_terms.update";
    ActionPermission["STAKING_TERMS_ALL"] = "staking_terms.*";
    ActionPermission["STAKING_READ"] = "staking.read";
    ActionPermission["STAKING_REQUEST_APPROVE"] = "staking_request.approve";
    ActionPermission["STAKING_REQUEST_REJECT"] = "staking_request.reject";
    ActionPermission["STAKING_ALL"] = "staking.*";
    ActionPermission["TICKETS_ALL"] = "tickets.*";
    ActionPermission["TICKETS_READ"] = "tickets.read";
    ActionPermission["KRAKEN_HISTORY_READ"] = "kraken_history.read";
    ActionPermission["KRAKEN_DEPOSIT_METHOD_READ"] = "kraken.read_deposit_methods";
    ActionPermission["KRAKEN_ASSETS_READ"] = "kraken.assets_read";
    ActionPermission["KRAKEN_HISTORY_ALL"] = "kraken_history.*";
    ActionPermission["KRAKEN_HISTORY_EXPORT_EXCEL"] = "kraken_history.export_excel";
    ActionPermission["BRANCHES_READ"] = "branches.read";
    ActionPermission["BRANCHES_WRITE"] = "branches.write";
    ActionPermission["BRANCHES_ALL"] = "branches.*";
    ActionPermission["EMPLOYEES_ALL"] = "employees.*";
    ActionPermission["EMPLOYEES_UPDATE_VAULT_ACCOUNT"] = "employees.update_vault_account";
    ActionPermission["BOG_TRANSACTIONS_READ"] = "bog_transactions.read";
    ActionPermission["BOG_TRANSACTIONS_EXPORT_EXCEL"] = "bog_transactions.export_excel";
    ActionPermission["WHITEBIT_TICKERS_READ"] = "whitebit.tickers_read";
    ActionPermission["BYBIT_ASSETS_READ"] = "bybit.assets_read";
    ActionPermission["CASH_TRANSACTIONS_ALL"] = "cash_transactions.*";
    ActionPermission["CASH_TRANSACTIONS_CREATE"] = "cash_transactions.create";
    ActionPermission["CASH_TRANSACTIONS_READ"] = "cash_transactions.read";
    ActionPermission["CASH_TRANSACTIONS_APPROVE"] = "cash_transactions.approve";
    ActionPermission["CASH_TRANSACTIONS_REJECT"] = "cash_transactions.reject";
    ActionPermission["CASH_TRANSACTIONS_CONFIRM"] = "cash_transactions.confirm";
    ActionPermission["CASH_TRANSACTIONS_EXPORT_EXCEL"] = "cash_transactions.export_excel";
    ActionPermission["FEATURES_ALL"] = "features.*";
    ActionPermission["FEATURES_READ"] = "features.read";
    ActionPermission["FEATURES_CREATE"] = "features.create";
    ActionPermission["FEATURES_UPDATE"] = "features.update";
    ActionPermission["FEATURES_DELETE"] = "features.delete";
    ActionPermission["JURISDICTIONS_READ"] = "jurisdictions.read";
    ActionPermission["JURISDICTIONS_CREATE"] = "jurisdictions.create";
    ActionPermission["JURISDICTIONS_UPDATE"] = "jurisdictions.update";
    ActionPermission["JURISDICTIONS_DELETE"] = "jurisdictions.delete";
    ActionPermission["JURISDICTIONS_DETAILS_READ"] = "jurisdictions.details_read";
    ActionPermission["JURISDICTIONS_READ_MOBILE_APP_VERSION"] = "jurisdictions.read_mobile_app_version";
    ActionPermission["LIQUIDATOR_READ"] = "liquidator.read";
    ActionPermission["JURISDICTION_LIQUIDATOR_ACCOUNT_READ"] = "jurisdiction_liquidator_accounts.read";
    ActionPermission["JURISDICTION_LIQUIDATOR_ACCOUNT_CREATE"] = "jurisdiction_liquidator_accounts.create";
    ActionPermission["JURISDICTION_LIQUIDATOR_ACCOUNT_DELETE"] = "jurisdiction_liquidator_accounts.delete";
    ActionPermission["INTERNAL_ACCOUNTS_ALL"] = "internal_accounts.*";
    ActionPermission["INTERNAL_ACCOUNTS_READ"] = "internal_accounts.read";
    ActionPermission["INTERNAL_ACCOUNTS_CREATE"] = "internal_accounts.create";
    ActionPermission["INTERNAL_ACCOUNTS_UPDATE"] = "internal_accounts.update";
    ActionPermission["EXTERNAL_WALLET_ALL"] = "external_wallet.*";
    ActionPermission["EXTERNAL_WALLET_READ"] = "external_wallet.read";
    ActionPermission["EXTERNAL_WALLET_EXPORT_EXCEL"] = "external_wallet.export_excel";
    ActionPermission["EXTERNAL_WALLET_GENERATE_ADDRESS"] = "external_wallet.generate_address";
    ActionPermission["EXTERNAL_WALLET_READ_ADDRESS"] = "external_wallet.address_read";
    ActionPermission["EXTERNAL_WALLET_DELETE"] = "external_wallet.delete";
    ActionPermission["EXTERNAL_WALLET_UPDATE"] = "external_wallet.update";
    ActionPermission["EXTERNAL_WALLET_CREATE"] = "external_wallet.create";
    ActionPermission["EXTERNAL_WALLET_EDIT_STATUS"] = "external_wallet.edit_is_active";
    ActionPermission["FIREBLOCKS_CREATE_VAULT_ASSET"] = "fireblocks.create_vault_asset";
    ActionPermission["FIREBLOCKS_READ_VAULT_ASSET"] = "fireblocks.read_vault_asset";
    ActionPermission["FIREBLOCKS_READ_ASSETS"] = "fireblocks.read_assets";
    ActionPermission["FIREBLOCKS_RESEND_WEBHOOK"] = "fireblocks.resend_webhook";
    ActionPermission["FIREBLOCKS_BALANCE_READ"] = "fireblocks.balance_read";
    ActionPermission["EXTERNAL_PROVIDERS_ALL"] = "external_providers.*";
    ActionPermission["EXTERNAL_PROVIDERS_BALANCES_READ"] = "external_providers.balances_read";
    ActionPermission["EXTERNAL_PROVIDERS_TRANSFER"] = "external_providers.transfer";
    ActionPermission["EXTERNAL_PROVIDERS_TRANSFER_HISTORY_READ"] = "external_providers.transfer_history_read";
    ActionPermission["EXTERNAL_PROVIDERS_RESERVE_EXCHANGE"] = "external_providers.exchange_using_reserve";
    ActionPermission["EXTERNAL_PROVIDERS_MARKET_EXCHANGE"] = "external_providers.exchange_using_market";
    ActionPermission["EXTERNAL_PROVIDERS_CALCULATE_EXCHANGE"] = "external_providers.calculate_exchange";
    ActionPermission["EXTERNAL_PROVIDERS_CONVERT_HISTORY_READ"] = "external_providers.convert_history_read";
    ActionPermission["EXTERNAL_PROVIDERS_ORDER_HISTORY_READ"] = "external_providers.order_history_read";
    ActionPermission["BONUS_HISTORY_ALL"] = "bonus_history.*";
    ActionPermission["BONUS_HISTORY_EXCEL_EXPORT"] = "bonus_history.excel_export";
    ActionPermission["BONUS_HISTORY_READ"] = "bonus_history.read";
    ActionPermission["BONUS_ACCRUALS_ALL"] = "bonus_accruals.*";
    ActionPermission["BONUS_ACCRUALS_READ"] = "bonus_accruals.read";
    ActionPermission["GAS_STATION_RULES_ALL"] = "gas_station_rules.*";
    ActionPermission["GAS_STATION_RULES_READ"] = "gas_station_rules.read";
    ActionPermission["GAS_STATION_RULES_EXPORT_EXCEL"] = "gas_station_rules.export_excel";
    ActionPermission["GAS_STATION_RULES_CREATE"] = "gas_station_rules.create";
    ActionPermission["GAS_STATION_RULES_UPDATE"] = "gas_station_rules.update";
    ActionPermission["GAS_STATION_RULES_DELETE"] = "gas_station_rules.delete";
    ActionPermission["GAS_STATION_HISTORY_ALL"] = "gas_station_history.*";
    ActionPermission["GAS_STATION_HISTORY_READ"] = "gas_station_history.read";
    ActionPermission["GAS_STATION_TRANSACTIONS_ALL"] = "gas_station_transactions.*";
    ActionPermission["GAS_STATION_TRANSACTIONS_READ"] = "gas_station_transactions.read";
    ActionPermission["PLATFORM_BANK_REQUISITES_ALL"] = "platform_bank_requisites.*";
    ActionPermission["PLATFORM_BANK_REQUISITES_READ"] = "platform_bank_requisites.read";
    ActionPermission["PLATFORM_BANK_REQUISITES_UPDATE"] = "platform_bank_requisites.update";
    ActionPermission["PLATFORM_BANK_REQUISITES_CREATE"] = "platform_bank_requisites.create";
    ActionPermission["BALANCE_RESERVES_ALL"] = "balance_reserves.*";
    ActionPermission["BALANCE_RESERVES_READ"] = "balance_reserves.read";
    ActionPermission["BALANCE_RESERVES_UPDATE"] = "balance_reserves.update";
    ActionPermission["BALANCE_RESERVES_HISTORY_READ"] = "balance_reserves_history.read";
    ActionPermission["REBALANCING_RULES_ALL"] = "rebalancing_rules.*";
    ActionPermission["REBALANCING_RULES_READ"] = "rebalancing_rules.read";
    ActionPermission["REBALANCING_RULES_EXPORT_EXCEL"] = "rebalancing_rules.export_excel";
    ActionPermission["REBALANCING_RULES_CREATE"] = "rebalancing_rules.create";
    ActionPermission["REBALANCING_RULES_UPDATE"] = "rebalancing_rules.update";
    ActionPermission["REBALANCING_RULES_DELETE"] = "rebalancing_rules.delete";
    ActionPermission["REBALANCING_RULES_EDIT_STATUS"] = "rebalancing_rules.edit_is_active";
    ActionPermission["REBALANCING_TRANSACTIONS_ALL"] = "rebalancing_transactions.*";
    ActionPermission["REBALANCING_TRANSACTIONS_READ"] = "rebalancing_transactions.read";
    ActionPermission["COLLECTOR_RULES_ALL"] = "collector_rules.*";
    ActionPermission["COLLECTOR_RULES_READ"] = "collector_rules.read";
    ActionPermission["COLLECTOR_RULES_EXPORT_EXCEL"] = "collector_rules.export_excel";
    ActionPermission["COLLECTOR_RULES_CREATE"] = "collector_rules.create";
    ActionPermission["COLLECTOR_RULES_UPDATE"] = "collector_rules.update";
    ActionPermission["COLLECTOR_RULES_DELETE"] = "collector_rules.delete";
    ActionPermission["COLLECTOR_RULES_EDIT_STATUS"] = "collector_rules.edit_is_active";
    ActionPermission["COLLECTOR_BOT_CALCULATE"] = "collector_bot.calculate";
    ActionPermission["COLLECTOR_BOT_TRIGGER"] = "collector_bot.trigger";
    ActionPermission["COLLECTOR_HISTORIES_READ"] = "collector_histories.read";
    ActionPermission["COLLECTOR_TRANSACTIONS_READ"] = "collector_transactions.read";
    ActionPermission["FINANCIAL_BOT_READ"] = "financial_bots.read";
    ActionPermission["FINANCIAL_BOT_EDIT"] = "financial_bots.update";
    ActionPermission["CRYPTO_WITHDRAWALS_RETRY"] = "crypto_withdrawals.retry";
    ActionPermission["CRYPTO_WITHDRAWALS_ACCEPT"] = "crypto_withdrawals.accept";
    ActionPermission["CRYPTO_WITHDRAWALS_REJECT"] = "crypto_withdrawals.reject";
    ActionPermission["CRYPTO_WITHDRAWALS_SET_APPROVAL_STATUS"] = "crypto_withdrawals.set_approval_status";
    ActionPermission["CRYPTO_WITHDRAWALS_READ"] = "crypto_withdrawals.read";
    ActionPermission["CRYPTO_WITHDRAWALS_ALL"] = "crypto_withdrawals.*";
    ActionPermission["SWAPS_ALL"] = "swaps.*";
    ActionPermission["SWAPS_READ"] = "swaps.read";
    ActionPermission["SWAPS_EDIT"] = "swaps.edit";
    ActionPermission["SWAPS_RESUME"] = "swaps.resume";
    ActionPermission["SWAPS_STATUS_UPDATE"] = "swaps.edit_status";
    ActionPermission["SWAPS_RETRY_REBALANCING"] = "swaps.retry_rebalancing";
    ActionPermission["BOG_BANK_WIRE_DEPOSITS_BLACKLIST_ALL"] = "bog_bank_wire_deposits_blacklist.*";
    ActionPermission["BOG_BANK_WIRE_DEPOSITS_BLACKLIST_READ"] = "bog_bank_wire_deposits_blacklist.read";
    ActionPermission["BOG_BANK_WIRE_DEPOSITS_BLACKLIST_WRITE"] = "bog_bank_wire_deposits_blacklist.write";
    ActionPermission["ARTICLES_ALL"] = "articles.*";
    ActionPermission["ARTICLES_READ"] = "articles.read";
    ActionPermission["ARTICLES_CREATE"] = "articles.create";
    ActionPermission["ARTICLES_EDIT"] = "articles.edit";
    ActionPermission["ARTICLES_DELETE"] = "articles.delete";
    ActionPermission["ARTICLES_SET_FEATURED"] = "articles.set_featured";
    ActionPermission["ARTICLE_CATEGORIES_ALL"] = "article_categories.*";
    ActionPermission["ARTICLE_CATEGORIES_READ"] = "article_categories.read";
    ActionPermission["ARTICLE_CATEGORIES_CREATE"] = "article_categories.create";
    ActionPermission["ARTICLE_CATEGORIES_EDIT"] = "article_categories.edit";
    ActionPermission["ARTICLE_CATEGORIES_DELETE"] = "article_categories.delete";
    ActionPermission["ADVERTISEMENTS_ALL"] = "advertisements.*";
    ActionPermission["ADVERTISEMENTS_READ"] = "advertisements.read";
    ActionPermission["ADVERTISEMENTS_CREATE"] = "advertisements.create";
    ActionPermission["ADVERTISEMENTS_EDIT"] = "advertisements.edit";
    ActionPermission["ADVERTISEMENTS_DELETE"] = "advertisements.delete";
    ActionPermission["PLATFORMS_ALL"] = "platforms.*";
    ActionPermission["PLATFORMS_READ"] = "platforms.read";
    ActionPermission["PLATFORMS_TOGGLE_UNDER_CONSTRUCTION"] = "platforms.toggle_under_construction";
    ActionPermission["PLATFORMS_TOGGLE_CRYPTO_WITHDRAWAL_APPROVAL"] = "platforms.toggle_crypto_withdrawal_approval";
    ActionPermission["COMPLIANCE_ALL"] = "compliance.*";
    ActionPermission["COMPLIANCE_READ"] = "compliance.read";
    ActionPermission["COMPLIANCE_EXPORT_EXCEL"] = "compliance.export_excel";
    ActionPermission["MANUAL_ACTIONS_ALL"] = "manual_actions.*";
    ActionPermission["MANUAL_ACTIONS_READ"] = "manual_actions.read";
    ActionPermission["MANUAL_ACTIONS_WRITE"] = "manual_actions.write";
    ActionPermission["MANUAL_ACTIONS_EXPORT_EXCEL"] = "manual_actions.export_excel";
    ActionPermission["MANUAL_ACTIONS_SET_APPROVAL"] = "manual_actions.set_approval";
    // SNOTE: those members are not assigned to any roles yet
    ActionPermission["USER_CONTACTS_READ"] = "user_contacts.read";
    ActionPermission["USER_DEVICES_READ"] = "user_devices.read";
    ActionPermission["USER_DEVICES_REVOKE"] = "user_devices.revoke";
    ActionPermission["USER_DEVICES_UPDATE_NAME"] = "user_devices.update_name";
    // -----------------------------
    // წასაშლელიი!!!!
    ActionPermission["BANK_WIRE_WITHDRAWAL_SET_APPROVAL_STATUS"] = "bank_wire_withdrawal.set_approval_status";
    ActionPermission["ADD_ADMIN_JURISDICTION"] = "ADD_ADMIN_JURISDICTION";
    ActionPermission["USERS_RESET_FR"] = "users.reset_fr";
    ActionPermission["ADD_EMPLOYEE_JURISDICTION"] = "ADD_EMPLOYEE_JURISDICTION";
    ActionPermission["EXTERNAL_PROVIDERS_CONVERT"] = "external_providers.convert";
    ActionPermission["JURISDICTIONS_SET_LIQUIDATOR"] = "jurisdictions.set_liquidator";
    ActionPermission["JURISDICTIONS_UPDATE_MAIN_QUOTE_ASSET"] = "jurisdictions.update_main_quote_asset";
    ActionPermission["JURISDICTIONS_UPDATE_LIQUIDATOR_ACCOUNT"] = "jurisdictions.update_liquidator_account";
    ActionPermission["JURISDICTIONS_UPDATE_DEFAULT_LIQUIDATOR_QUOTE_ASSET"] = "jurisdictions.default_liquidator_quote_asset";
    ActionPermission["JURISDICTIONS_SET_MOBILE_APP_VERSION"] = "jurisdictions.set_mobile_app_version";
    ActionPermission["BANK_WIRE_WITHDRAWAL_APPROVE"] = "bank_wire_withdrawal.approve";
    ActionPermission["BANK_WIRE_WITHDRAWAL_FORCE_REJECT"] = "bank_wire_withdrawal.force_reject";
    ActionPermission["EXTERNAL_BALANCES_ALL"] = "external_balances.*";
    ActionPermission["EXTERNAL_BALANCES_READ"] = "external_balances.read";
    ActionPermission["EXTERNAL_BALANCES_EXPORT_EXCEL"] = "external_balances.export_excel";
    ActionPermission["EXTERNAL_WALLET_ADDRESS_GENERATE"] = "EXTERNAL_WALLET_ADDRESS_GENERATE";
    ActionPermission["CARD_PAYMENT_MERCHANTS_ALL"] = "card_payment_merchants.*";
    ActionPermission["CARD_PAYMENT_MERCHANTS_READ"] = "card_payment_merchants.read";
    ActionPermission["CARD_PAYMENT_MERCHANTS_UPDATE"] = "card_payment_merchants.update";
    ActionPermission["CARD_PAYMENT_MERCHANTS_CREATE"] = "card_payment_merchants.create";
    ActionPermission["CARD_LOCKED_USERS_ALL"] = "card_locked_users.*";
    ActionPermission["CARD_LOCKED_USERS_READ"] = "card_locked_users.read";
    ActionPermission["CARD_LOCKED_USERS_EXPORT_EXCEL"] = "card_locked_users.export";
    ActionPermission["KURSIGE_SETTLEMENTS_ALL"] = "kursige_settlements.*";
    ActionPermission["KURSIGE_SETTLEMENTS_READ"] = "kursige_settlements.read";
    ActionPermission["KURSIGE_SETTLEMENTS_WRITE"] = "kursige_settlements.write";
    ActionPermission["KURSIGE_SETTLEMENTS_EXPORT_EXCEL"] = "kursige_settlements.export_excel";
})(ActionPermission || (ActionPermission = {}));
//# sourceMappingURL=action-permission.enum.js.map